module.exports = __webpack_public_path__ + "static/media/245-ivory-coast.bfb93d20.svg";